import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';
const TiposEventosTable = ({ tiposeventos, setIdTipoEvento, setOpenModal }) => {
  const columns = [
    {
      accessorKey: 'clave',
      header: 'Clave',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'descripcion',
      header: 'Tipo',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idtipoeventos',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idtipoeventos } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdTipoEvento(idtipoeventos);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                      variant="falcon-default"
                      size="sm"
                      title="Eliminar"
                      onClick={() => {
                        setIdMunicipioToDelete(idmunicipio);
                        setOpenConfirm(true);
                      }}
                    >
                      <FontAwesomeIcon icon="trash-alt" />
                    </Button> */}
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={tiposeventos}
        title="Tipos de Eventos"
        columns={columns}
        addAction={() => {
          setIdTipoEvento(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};

TiposEventosTable.propTypes = {
  setOpenModal: PropTypes.func.isRequired,
  setIdTipoEvento: PropTypes.func.isRequired,
  tiposeventos: PropTypes.array
};
export default TiposEventosTable;
